import type { GetPasskeyRegistrationOptionsResponse } from '@dynamic-labs/sdk-api-core';

import { getCore } from '../../../../client/core/getCore';
import type { DynamicClient } from '../../../../client/types';
import { createApiClient } from '../../../apiClient';

export const getPasskeyRegistrationOptions = async (
  client: DynamicClient
): Promise<PublicKeyCredentialCreationOptionsJSON> => {
  const core = getCore(client);

  const apiClient = createApiClient({}, client);

  const options: GetPasskeyRegistrationOptionsResponse =
    await apiClient.getPasskeyRegistrationOptions({
      environmentId: core.environmentId,
    });

  return options as PublicKeyCredentialCreationOptionsJSON;
};
